<!-- Begin: Admin Form -->
<div class="mw2000 center-block">
  <div class="admin-form">

    <div class="panel heading-border">
      <div class="panel-body bg-light">
        <!--""-->
        <form ngNativeValidate [formGroup]="forma" (ngSubmit)="createOrder()" method="post" id="form-ui">
          <div class="section-divider mb40" id="spy1">
            <span>Order Form</span>
          </div>
          <!-- .section-divider -->

          <!-- Basic Inputs -->
          <div class="row">



            <div class="col-md-7">

              <div class="row">
                <div class="col-md-12">
                  <div class="col-md-6">
                    <div class="section">
                    <mat-form-field class="example-full-width">
                      <mat-label>Select Customer</mat-label>
                      <mat-select formControlName="selected" (selectionChange)="selectCustomer($event)">

                        <mat-option  *ngFor="let cus of customers" [value]="cus.id">{{ cus.companyname }}</mat-option>
                      </mat-select>

                      <mat-error *ngIf="forma.controls.selected.hasError('required')">You must make a selection</mat-error>

                    </mat-form-field>

                  </div>

                  <!--   <div class="section">
                      <label class="field select ">
                        <select id="customer" formControlName="customer" name="customer"
                          (change)="selectCustomer($event)">
                          <option selected value="0">Select Customer</option>
                          <option *ngFor="let cus of customers" value="{{ cus.id }}"> {{ cus.companyname }} </option>
                        </select>
                        <i class="arrow "></i>
                      </label>
                    </div>-->
                  </div>

                </div>
              </div>

            <div class="row">
              <div class="col-md-12">
                <div class="col-md-12">
                <div class="section">
                  <mat-form-field class="example-full-width">
                    <mat-label>Company</mat-label>
                    <input matInput formControlName="companyname" name="companyname" id="companyname" readonly>
                  </mat-form-field>
                </div>
                </div>
              </div>
            </div>


              <div class="row">
                <div class="col-md-12">
                  <div class="col-md-6">
                    <div class="section">

                      <mat-form-field class="example-full-width">
                        <mat-label>Customer Firstname</mat-label>
                        <input matInput formControlName="firstnamecontact" name="firstnamecontact" id="firstnamecontact" readonly>
                      </mat-form-field>

                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="section">

                      <mat-form-field class="example-full-width">
                        <mat-label>Customer Lastname</mat-label>
                        <input matInput formControlName="lastnamecontact" name="lastnamecontact" id="lastnamecontact" readonly>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>


              <div class="row">
                <div class="col-md-12">
                  <div class="col-md-6">
                    <div class="section">

                      <mat-form-field class="example-full-width">
                        <mat-label>Address</mat-label>
                        <input matInput formControlName="address" name="address" id="address" readonly>
                      </mat-form-field>

                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="section ">

                      <mat-form-field class="example-full-width">
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="phone" name="phone" id="phone" readonly>
                      </mat-form-field>

                    </div>
                  </div>
                </div>
              </div>


              <div class="row">
                <div class="col-md-4">

                  <div class="col-md-4">
                    <label style="margin-top: 14px; font-size: 12px" for="datetimepicker2">Delivery Date</label>
                  </div>
                  <div class="col-md-8">
                    <div class="section">




                     <mat-form-field class="example-full-width">
                        <mat-label>Delivery Date</mat-label>
                        <input matInput [matDatepicker]="pickerdos" formControlName="datedelivery" name="datedelivery">
                        <mat-datepicker-toggle matSuffix [for]="pickerdos"></mat-datepicker-toggle>
                        <mat-datepicker  #pickerdos color="primary"></mat-datepicker>
                      </mat-form-field>


                    </div>
                  </div>

                </div>

                <div class="col-md-4">

                  <div class="col-md-4">
                    <label style="margin-top: 14px; font-size: 12px" for="datetimepicker2">Hour From</label>
                  </div>
                  <div class="col-md-8">
                    <div class="section ">
                        <mat-form-field class="example-full-width">
                          <mat-label>Hour from</mat-label>
                          <input matInput  formControlName="hourdeliveryfrom" id="hourdeliveryfrom" name="hourdeliveryfrom" [ngxTimepicker]="horapicker">
                          <ngx-material-timepicker #horapicker></ngx-material-timepicker>
                        </mat-form-field>
                        <!-- <label class="field append-icon">
                        <input class="form-control" formControlName="hourdeliveryfrom" id="hourdeliveryfrom" name="hourdeliveryfrom" [ngxTimepicker]="picker"
                          placeholder="Hour Delivery from">
                        <ngx-material-timepicker #picker></ngx-material-timepicker>

                        <label for="phone " class="field-icon ">
                          <i class="fa fa-clock-o"></i>
                        </label>
                      </label>-->
                    </div>
                  </div>
                </div>

                <div class="col-md-4">

                <div class="col-md-4">
                  <label style="margin-top: 14px; font-size: 12px" for="datetimepicker2">Hour To</label>
                  </div>
                   <div class="col-md-8">
                    <div class="section ">
                      <mat-form-field class="example-full-width">
                        <mat-label>Hour to</mat-label>
                        <input matInput  formControlName="hourdeliveryto" id="hourdeliveryto" name="hourdeliveryto" [ngxTimepicker]="horapicker2">
                        <ngx-material-timepicker #horapicker2></ngx-material-timepicker>
                      </mat-form-field>
                    </div>
                   </div>
                 </div>
              </div>



              <div class="row">
                  <div class="col-md-6 ">
                    <div class="col-md-4">
                      <label style="margin-top: 18px; font-size: 12px" for="datetimepicker2">Status</label>
                    </div>
                    <div class="col-md-8">
                    <div class="section">
                        <!--
                              <input type="checkbox" formControlName="status" name="status" id="f1" checked>
                              <label for="f1" data-on="ON" data-off="OFF"></label>
                        <span>Status</span>
                        -->

                        <mat-form-field class="example-full-width">


                          <mat-select formControlName="status" [(ngModel)]="selectedStatus">

                            <mat-option value="0">Pending


                          </mat-option>
                          </mat-select>

                          <mat-error *ngIf="forma.controls.status.hasError('required')">You must make a selection</mat-error>

                        </mat-form-field>
                    </div>
                    </div>

                </div>



              </div>

              <div class="row">

                <div class="col-md-12">

                  <div class="col-md-2">
                    <label style="margin-top: 14px; font-size: 12px" for="datetimepicker2">Description</label>
                  </div>
                  <div class="col-md-10">

                    <mat-form-field class="example-full-width">
                      <mat-label>Leave a comment</mat-label>
                      <textarea matInput placeholder="Description by delivery..." formControlName="description" id="description" name="description" rows=5></textarea>
                    </mat-form-field>


                </div>

              </div>
              </div>

            </div>



              <div class="col-md-5" style="margin-bottom:30px">
                <div #mapContainer id="map">

                </div>


                <div class="row">
                  <div  class="col-md-12">


                    <div class="col-md-4">


                      <div class="col-md-12">
                        <div class="section ">


                          <mat-form-field class="example-full-width">
                            <mat-label>Distance</mat-label>
                            <input matInput  formControlName="distance" id="distance" name="distance"  value=" {{distance}}">

                          </mat-form-field>



                        </div>
                      </div>
                    </div>





                    <div class="col-md-4">

                      <div class="col-md-12">

                          <div class="section ">

                            <mat-form-field class="example-full-width">
                              <mat-label>Time</mat-label>
                              <input matInput  formControlName="time" id="time" name="time"  value=" {{time}}">

                            </mat-form-field>



                          </div>
                      </div>

                    </div>


                    <div class="col-md-4">

                        <div class="col-md-12">
                          <div class="section ">

                            <mat-form-field class="example-full-width">
                              <mat-label>Total</mat-label>
                              <input matInput  formControlName="total" id="total" name="total"  value=" {{total}}">

                            </mat-form-field>



                          </div>
                        </div>

                    </div>


              </div>
                </div>

              </div>

          </div>
            <!-- end .form-body section -->
            <div class="panel-footer text-center ">
              <button type="submit" class="button btn-primary ">Create Order</button>
            </div>
            <!-- end .form-footer section -->
        </form>
      </div>

  </div>

